import {
    GENERAL_ERROR_MESSAGE_HEADER,
    GENERAL_ERROR_MESSAGE__SUB_HEADER_1,
    GENERAL_ERROR_MESSAGE__SUB_HEADER_2,
} from '../consts'
import useStyles from './RouterErrorFallback.styles'

const RouterErrorFallback = ({
    error,
}: Readonly<{
    error: {
        status?: number,
        statusText?: string,
        message?: string,
    },
}>) => {
    const {
        classes,
    } = useStyles()

    // eslint-disable-next-line no-console
    console.error('RouterErrorBoundary caught an error:', error)

    return (
        <div className={classes.body}>
            <div className={classes.icon}>
                <img
                    className={classes.icon}
                    src="assets/images/icons/failed.svg"
                    alt="error"
                />
            </div>
            <div className={classes.title}>{GENERAL_ERROR_MESSAGE_HEADER}</div>
            <div className={classes.subTitle}>{GENERAL_ERROR_MESSAGE__SUB_HEADER_1}</div>
            <div className={classes.subTitle}>{GENERAL_ERROR_MESSAGE__SUB_HEADER_2}</div>
        </div>
    )
}

export default RouterErrorFallback
